import React, {useEffect, useState } from "react";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  Table,
  Input,
  Label,
  Modal,
  Button,
  InputGroup,

} from "reactstrap";


// Redux
import { connect, useDispatch} from "react-redux";
import { withRouter, Link} from "react-router-dom";


//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Pagination from "../../components/Common/Pagination";
import Loader from "../../components/Common/Loader";

import SweetAlert from "react-bootstrap-sweetalert";
//Action
import { grupotecnicoCreate, grupotecnicoList,  grupotecnicoDelete , grupotecnicoUpdate} from "../../store/grupoTecnico/actions";

const GrupoTecnicoCreate = (props) => {
 
    const dispatch= useDispatch();
    const user = JSON.parse(localStorage.getItem("user"))
    const groups  =String(user.groups);





useEffect(() => {
  dispatch(grupotecnicoList());
},[dispatch]);


const [show, setShow] = useState(false);
const [show_txt, setShow_txt] = useState(false);
console.log(show_txt)
const [showEdit, setShowEdit] = useState(false);
const [grupo_tecnicoNombre, setGrupoTecnicoNombre] = useState("");
const [error, setError] = useState(false)
const [id, setid] = useState(false)


const handlegrupoTecnicoCreate = ()=>{
    setShow(true)
};
const handlegrupoTecnicoEdit = (grupo_tecnico)=>{
    setShowEdit(true)

    setGrupoTecnicoNombre(grupo_tecnico.nombre)
    setid(grupo_tecnico.id)
    console.log(grupo_tecnico.nombre)
};

const handleGrupoTecnicoNombre = (e)=>{
  setGrupoTecnicoNombre(e.target.value)
};

const onSubmitGrupoTecnico = ()=>{
  if(grupo_tecnicoNombre !== ""){
    dispatch(grupotecnicoCreate({
        nombre: grupo_tecnicoNombre,
    }))
    setShow(false);
  }
  else{
    setError(true);
  }

}

const onEditGrupoTecnico = ()=>{
  if(grupo_tecnicoNombre !== ""){
    dispatch(grupotecnicoUpdate(id,{
        nombre: grupo_tecnicoNombre,
    }))
    setShowEdit(false);
  }
  else{
    setShowEdit(true);
  }

}

const deleteGrupoTecnico = (id)=>{
  dispatch(grupotecnicoDelete(id));
  
}
console.log(props)
const params = {
  count: props.grupotecnico.count,
  next: props.grupotecnico.next,
  previous: props.grupotecnico.previous,
  results: props.grupotecnico.results,
};

    return ( 
         <React.Fragment>
             <div className="page-content">
                <MetaTags>
                    <title>tccontrol | Grupos Tecnicos</title>
                </MetaTags>
                <Container fluid>
                {/* Render Breadcrumb */}
                <Breadcrumb title={"tccontrol"} breadcrumbItem={"Grupo Tecnicos"} />
                        {props.loading ? (
                        <Loader />
                        ) : (
                            <div>
                                 {props.grupotecnicoCreated.id  ? (
                                    <SweetAlert
                                      title="Hecho!"
                                      success
                                      timeout={1000}
                                      showConfirm={false}
                                      onConfirm={() => {
                                        dispatch (grupotecnicoList());
                                      }}
                                    >
                                      Se ha agregado el Grupo con éxito 
                                    </SweetAlert>
                                  ) : null}

                                  {error  ? (
                                    <SweetAlert
                                      title="Error"
                                      warning
                                      timeout={1000}
                                      showConfirm={false}
                                      onConfirm={() => {
                                        setError(false);
                                      }}
                                    >
                                      Este Campo no puede estar Vacio
                                    </SweetAlert>
                                  ) : null}

                                  {props.grupotecnicoDeleted  ? (
                                    <SweetAlert
                                      title="Hecho!"
                                      success
                                      timeout={1000}
                                      showConfirm={false}
                                      onConfirm={() => {
                                        dispatch(grupotecnicoList());
                                      }}
                                    >
                                      Se ha borrado el Grupo Correctamente
                                    </SweetAlert>
                                  ) : null}

                              {/* Card del Modal */}
                                <Card className= "col-lg-10 mx-auto  mt-3">

                                  {/* Modale Create */}
                                <Modal
                                    isOpen={show}
                                    centered={true}
                                    toggle = {()=> setShow(false)}
                                    

                                  >
                                    <div className="modal-header">
                                        <h3 className="modal-title mt-2">
                                            Grupo de Tecnicos
                                        </h3>
                                        <button
                                            type="button"
                                            onClick={() => {
                                               setShow_txt("")
                                                setShow(false);
                                            }}
                                            className="close"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                        >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                                </div>
                                                <div className="modal-body">
                                                <Row className="col-lg-12 justify-content-center">
                                                <Col lg={10} className="mb-3">
                                                    <Label
                                                      for="nombre"
                                                      className="form-label"
                                                    >
                                                  Nombre
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        name="nombre"
                                                        placeholder="Escriba un Grupo de Tecnico"
                                                        onChange={handleGrupoTecnicoNombre}
                                                        
                                                      />
                                                  </Col>
                                                        </Row>

                                                      <div className="modal-footer">
                                                        <button
                                                          type="button"
                                                          className="btn btn-secondary"
                                                          onClick={() => {                        
                                                            setShow(false)
                                                          }}
                                                          > Atras
                                                        </button>
                                                        <button
                                                          type="button"
                                                          className="btn btn-primary"
                                                          onClick={()=> onSubmitGrupoTecnico()}   
                                                        >
                                                              Guardar
                                                        </button>
                                                      </div>
                                                    </div>
                                                    </Modal>
                                
                                {/* Modale Edit */}

                                {props.grupotecnicoUpdated.id  ? (
                                    <SweetAlert
                                      title="Hecho!"
                                      success
                                      // timeout={2000}
                                      showConfirm={true}
                                      onConfirm={() => {
                                        dispatch (grupotecnicoList());
                                      }}
                                    >
                                      Se ha actualizado  el Grupo con éxito 
                                    </SweetAlert>
                                  ) : null}

                                  {error  ? (
                                    <SweetAlert
                                      title="Error"
                                      warning
                                      // timeout={2000}
                                      showConfirm={true}
                                      onConfirm={() => {
                                        
                                        setError(false);
                                      }}
                                    >
                                      Este Campo no puede estar Vacio
                                    </SweetAlert>
                                  ) : null}

                                <Modal
                                    isOpen={showEdit}
                                    centered={true}
                                    toggle = {()=> {
                                      
                                      setShowEdit(false)
                                    }}
                                    

                                  >
                                    <div className="modal-header">
                                        <h3 className="modal-title mt-2">
                                            Grupo de Tecnicos
                                        </h3>
                                        <button
                                            type="button"
                                            onClick={() => {
                                               
                                                setShowEdit(false);
                                            }}
                                            className="close"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                        >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                                </div>
                                                <div className="modal-body">
                                                <Row className="col-lg-12 justify-content-center">
                                                <Col lg={10} className="mb-3">
                                                    <Label
                                                      for="nombre"
                                                      className="form-label"
                                                    >
                                                  Nombre
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        name="nombre"
                                                        placeholder="Escriba un Grupo de Tecnico"
                                                        onChange={handleGrupoTecnicoNombre}
                                                        defaultValue={grupo_tecnicoNombre}
                                                      />
                                                  </Col>
                                                        </Row>

                                                      <div className="modal-footer">
                                                        <button
                                                          type="button"
                                                          className="btn btn-secondary"
                                                          onClick={() => {                        
                                                            setShowEdit(false)
                                                          }}
                                                          > Atras
                                                        </button>
                                                        <button
                                                          type="button"
                                                          className="btn btn-primary"
                                                          onClick={()=> onEditGrupoTecnico()}   
                                                        >
                                                              Guardar
                                                        </button>
                                                      </div>
                                                    </div>
                                                    </Modal>



                                {/* Cardbody de boton de agregar y filtro */}
                                <CardBody>
                                      <Row>
                                        <Col md={7}>
                                        {groups.includes("SuperAdmin") ||  groups.includes("Supervisor") || groups.includes("Operador") ? (
                                          <Link
                                            className="btn btn-primary waves-effect waves-light"
                                            to="#"
                                            onClick={handlegrupoTecnicoCreate}
                                          >
                                            Agregar Nuevo Grupo{" "}
                                            <span className=""></span>
                                          </Link>
                                        ):null}
                                        </Col>
                                        <Col md={5}>
                                          <Form
                                            className="search-box"
                                          //   onSubmit={onSubmit}
                                          >
                                            <InputGroup>
                                              <Input
                                                type="text"
                                                className="form-control"
                                                name="search"
                                                placeholder="Buscar"
                                              //   value={search}
                                              //   onChange={onChange}
                                                
                                              />
                                              <i className="bx bx-search-alt search-icon" />
                                              <Button color="primary" 
                                              // onClick={resetSearch}

                                              >
                                                <span className=" bx bx-x fa-lg align-middle"></span>
                                              </Button>
                                            </InputGroup>
                                          </Form>
                                        </Col>
                                      </Row>
                                 </CardBody>



                                </Card>

                                          {/* Card de la tabla */}
                                <Card className= "col-lg-10 mx-auto  mt-3">
                                {params.count !== 0 ? (
                                       <CardBody>
                                       <h4 className="card-title">Grupos de Tecnicos</h4>
                                       <div className="table-responsive">
                                         <Table
                                           className="table table-lg table-borderless table-striped align-middle table-centered table-nowrap mb-3 "
                                           style={{
                                             textAlign: "center",
                                           }}
                                           hover
                                         >
                                           <thead className="table-light">
                                             <tr>
                                               <th>#</th>
                                               <th>Grupo de Tecnicos</th>
                                               {groups.includes("SuperAdmin") ||  groups.includes("Supervisor") || groups.includes("Operador") ? (
                                               <th>Acción</th> 
                                               ):null}
                                             </tr>
                                           </thead>
                                           <tbody>
                                               {params.results &&
                                                 params.results.map((grupo_tecnico, idx) => (
                                                   <tr key={idx}>
                                                     <th scope="row">{idx + 1}</th>
                                                     <td>{grupo_tecnico.nombre}</td>                                
                                                     <td>
                                                     {groups.includes("SuperAdmin") ||  groups.includes("Supervisor") || groups.includes("Operador") ? (
                                                     
                                                         <span 
                                                         className="bx bx-edit bx-sm align-middle"
                                                        style={{ cursor: "pointer", color: "#045e94" }}
                                                        onClick={() => handlegrupoTecnicoEdit(grupo_tecnico)}
                                                         ></span>
                                                          
                                                       ):null} {" "}
                                                    {groups.includes("SuperAdmin") ||  groups.includes("Supervisor")  ? (
                                                     <>
                                                                                    
                                                
                                                       <span className="bx bx-trash bx-sm align-middle"
                                                        style={{ cursor: "pointer", color: "#045e94" }}
                                                        onClick={() => deleteGrupoTecnico(grupo_tecnico.id)}
                                                       ></span>
                                                      
                                                    
                     
                                                   
                                                    
                                                     </>
                                                   ): null}
                                                     </td> 
                                                   </tr>
                                                 ))}
                                             </tbody>
                                           
                                         </Table>
                                       </div>
                                        <Pagination
                                           count={params.count}
                                           next={params.next}
                                           previous={params.previous}
                                           limit={10}
                                           baseUrl="rol/"
                                          //  filterFunction={rolFilter}
                                         />
                                     </CardBody>

                                   ) : ( 
                                    <CardBody>
                                    <h4 className="card-title">No se encontraron resultados</h4>
                                  </CardBody>
                                   )}
                                </Card>
                            </div>
                            )}
                </Container>
                </div>
         </React.Fragment>
     );
}
 
const mapStateToProps = (state) => {
  const { error, loading, grupotecnico, grupotecnicoCreated, grupotecnicoDeleted, grupotecnicoUpdated} = state.GrupoTecnico;
  return { error, loading, grupotecnico, grupotecnicoCreated , grupotecnicoDeleted,grupotecnicoUpdated};
};
GrupoTecnicoCreate.propTypes = {
    error: PropTypes.any,
    loading: PropTypes.bool,
    grupotecnicoCreated: PropTypes.object,
    grupotecnicoDeleted: PropTypes.object,
    grupotecnicoUpdated: PropTypes.object,

    };
export default withRouter(connect(mapStateToProps , { grupotecnicoList, grupotecnicoCreate, grupotecnicoDelete , grupotecnicoUpdate}) (GrupoTecnicoCreate));